import { Link } from "react-router-dom";
const DesktopResetPasswordForm = ({
	form,
	onSubmit,
	password,
	confirmPassword,
}) => {
	const { register, handleSubmit, formState, setPassword, setConfirmPassword } =
		form;
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-[16px]"
		>
			{/* Input wrapper with icon and clear button */}
			<div className="relative h-[33px]">
				{/* Left Icon */}
				<div className="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
					<img
						src="/assets/verify-otp/img.svg"
						alt="icon"
						className="w-4 h-4"
					/>
				</div>

				{/* Input field */}
				<input
					id="password"
					type="text"
					{...register("password")}
					placeholder="New Password"
					className="no-spinner w-full h-full rounded-[8px] border border-[#193D34] pl-8 pr-10 p-[8px] outline-none"
				/>

				{/* Clear (×) Button */}
				{password && (
					<button
						type="button"
						onClick={() => setPassword("password", "")}
						className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-800"
					>
						×
					</button>
				)}
			</div>
			{formState.errors.password && (
				<p className="text-red-500 text-sm mt-1">
					{formState.errors.password.message}
				</p>
			)}
			{/* Input wrapper with icon and clear button */}
			<div className="relative h-[33px]">
				{/* Left Icon */}
				<div className="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
					<img
						src="/assets/verify-otp/img.svg"
						alt="icon"
						className="w-4 h-4"
					/>
				</div>

				{/* Input field */}
				<input
					id="confirm-password"
					type="text"
					{...register("confirmPassword")}
					placeholder="Confirm Password"
					className="no-spinner w-full h-full rounded-[8px] border border-[#193D34] pl-8 pr-10 p-[8px] outline-none"
				/>

				{/* Clear (×) Button */}
				{confirmPassword && (
					<button
						type="button"
						onClick={() => setConfirmPassword("")}
						className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-800"
					>
						×
					</button>
				)}
			</div>
			{formState.errors.confirmPassword && (
				<p className="text-red-500 text-sm mt-1">
					{formState.errors.confirmPassword.message}
				</p>
			)}
			{/* Submit + Support */}
			<div className="w-full h-[82px] flex flex-col items-center justify-center mx-auto gap-[16px] mt-[40px]">
				<button
					type="submit"
					className="w-full h-[32px] flex items-center justify-center rounded-[24px] p-[8px] bg-deepForest text-white text-[13px] font-[500] font-montserrat leading-[24px] text-center"
				>
					Change Password
				</button>
			</div>
		</form>
	);
};

export default DesktopResetPasswordForm;
